<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    Edit GA Transient Parking Information
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <mat-form-field>
        <mat-select placeholder="GA Transient Parking Available *" [(value)]="selectedGatParking" name="parking" formControlName="parking">
          <mat-option value="Unknown">Unknown</mat-option>
          <mat-option value="Yes">Yes</mat-option>
          <mat-option value="No">No</mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <div id="parking">
        <mat-checkbox formControlName="parking" [(ngModel)]="selectedGatParking">GA Transient Parking Available</mat-checkbox>
      </div> -->
      <div id="charted">
        <mat-checkbox [disabled]="selectedGatParking !== 'Yes'" formControlName="charted">Parking Charted</mat-checkbox>
      </div>
      <mat-form-field id="descriptionField">
        <input matInput
               placeholder="Parking Location/Description"
               formControlName="description"
               [attr.disabled]="selectedGatParking !== 'Yes' ? '' : null"
               [(ngModel)]="selectedGatDescription">
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
